import EventHandler from '@pixelunion/events';

export default class Accordion {
  constructor() {
    this.accordions = document.querySelectorAll('.accordion');
    this.events = new EventHandler();

    if (!this.accordions) { return; }

    this.accordions.forEach(accordion => {
      const accordionLink = accordion.querySelectorAll('dt a');

      if (!accordionLink) { return; }

      accordionLink.forEach(link => {
        const content = link.parentNode.nextElementSibling;

        this.events.register(link, 'click', event => {
          event.preventDefault();
          link.classList.toggle('active');
          this.toggleContent(content);
        });
      });
    });
  }

  toggleContent(content) {
    content.classList.toggle('active');
  }
}
